import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import ZoneForm from 'Services/ControlDataManagement/Features/Zone/Components/ZoneForm'
import { SELECTED_ZONE_PARAMETER_KEY } from 'Services/ControlDataManagement/Features/Zone/Hooks/useZonesWithParams'
import { useGetSingleZoneQuery } from 'Services/ControlDataManagement/Features/Zone/zoneApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function ZoneEditPage() {
  const baseUrl = `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/zones`
  const { id } = useParams()
  const previousLocation = usePreviousLocation(`${baseUrl}?${SELECTED_ZONE_PARAMETER_KEY}=${id}`)
  const { data: singleZone, isFetching: isSingleZoneFetching } = useGetSingleZoneQuery(id ?? '', {
    skip: !id
  })

  const breadcrumbs = [
    {
      title: t`Home`,
      link: CONTROL_DATA_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Zones`,
      link: baseUrl
    },
    {
      title: t`Edit zone`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit zone`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isSingleZoneFetching}>
        <ZoneForm successBaseUrl={previousLocation} zone={singleZone} />
      </WithLoader>
    </Box>
  )
}
